module.exports = __webpack_public_path__ + "static/media/Portrait-10055.9fdc6017.jpg";